import { isSingleLineRibbon } from 'owa-command-ribbon-store/lib/selectors/isSingleLineRibbon';
import type { CommandCenterRenderingContext } from 'owa-copilot-command-center-store';

const SingleLineRenderingContexts: CommandCenterRenderingContext[] = [
    'CalendarEventForm',
    'CalendarAiModeToolbar',
];

export function getIsSingleLineRibbon(
    renderingContext: CommandCenterRenderingContext | undefined
): boolean {
    renderingContext = renderingContext ?? 'Other';
    return SingleLineRenderingContexts.includes(renderingContext) || isSingleLineRibbon();
}
